import { QueriesResults, useQueries } from 'react-query';
import { FileWithExternalLink } from '../../../design-system/src';

export const getPublicFile = async (
  link: string,
): Promise<FileWithExternalLink> => {
  const response = await fetch(link);
  const responseBlob = await response.blob();
  return {
    file: new File(
      [responseBlob],
      link.split('/').splice(-1)[0].split('?')[0],
      {
        type: response.headers.get('Content-Type') || '',
      },
    ),
    externalLink: link,
  };
};

const usePublicFiles = (
  links: string[],
): QueriesResults<FileWithExternalLink[]> => {
  return useQueries<FileWithExternalLink[]>(
    links.map((link) => ({
      queryKey: link,
      queryFn: () => getPublicFile(link),
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    })),
  );
};

export default usePublicFiles;
